import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const annotationRouteService = {
  getList,
  storeOrUpdate,
  destroy
};

function getList(propertyId, layerId) {
  const params = layerId ? `property_id=${propertyId}&layer_id=${layerId}` : `property_id=${propertyId}`;
  return axios
    .get(`${apiEndpoint.annotationRoutes}?${params}`, {
      headers: authHeader(),
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { code: 'error', message: 'Request failed' };
    });
}

function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.annotationRoutes(id), data, { headers: authHeader() })
    : axios.post(apiEndpoint.annotationRoutes, data, { headers: authHeader() })
  ).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.annotationRoutes(id), { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
